
import { PropTypes } from 'prop-types';
import { Link } from 'react-router-dom';

const CampusLifeCard = ({ img,size, title,link ,description ,light }) => {
    return (
        <div className="border-t border-dashed w-full border-t-slate-400 md:p-2  py-3">
            <div
               
                className={`grid grid-cols-1 md:grid-cols-[20%_78%]  py-2 md:p-2 px-4 gap-4 rounded-lg  items-stretch group    ${light ? "hover:!text-[#0039cb] h-animate hover:bg-white" : ""} `}>
                <div className='w-24  px-3 pt-1 self-stretch'>
                    <img src={img} className='object-cover' width={size} height={500} alt={title} />
                </div>
                <div className='flex flex-col gap-2  h-full w-full'>
                    <h1 className={`font-bold    text-lg lg:text-lg  2xl:text-3xl `}>{title}</h1>
                    <p className={`w-full text-justify md:text-left text-xs 2xl:w-11/12 line-clamp-4 lg:text-[10px] 2xl:text-sm mt-1 ${light ? "group-hover:!text-black" : ""}`}>{description}</p>
                   {light && <Link to={link} className='p-2 px-3 hidden group-hover:block border w-fit rounded-sm transition-all delay-200 font-bold text-xs text-[#0039cb] border-[#0039cb]'>Learn More</Link>}
                </div>
            </div>
        </div>
    )
}
CampusLifeCard.propTypes = {
    img: PropTypes.string.isRequired,
    size: PropTypes.number,
    title: PropTypes.string.isRequired,
    link: PropTypes.string,
    light:PropTypes.bool,
    description: PropTypes.string.isRequired
}
export default CampusLifeCard